module.exports = __webpack_public_path__ + "img/new.acf60b18.svg";